export default "__VITE_ASSET__BfHmg0fe__"